import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms'
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTabsModule } from '@angular/material/tabs';
import { NotFound } from '../app/pages/not-found/not-found';
import { TutorialComponent } from './modal/tutorial/tutorial.component';
import { ErrorLogService } from './service/error-log.service';





@NgModule({
    declarations: [
        AppComponent,
        NotFound,
        TutorialComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        HttpClientModule,
        FormsModule,
        MatToolbarModule,
        MatTabsModule,

    ],
    providers: [
        ErrorLogService
    ],
    bootstrap: [
        AppComponent
    ]
})

export class AppModule { }
